var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('bulletin-top-bubble-label',{attrs:{"content":_vm.bulletinData.content},on:{"close":_vm.onClickClose,"look":_vm.onClickViewDetail}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }